import React from 'react'
import { connect } from 'react-redux'
import { formValues } from 'redux-form'
import { isEmpty, unionBy } from 'lodash'
import { compose } from 'lodash/fp'
import { Select } from '../../../../components/FormBuilder'
import mapRoomTypeToIcon from '../../../../models/Room/mappers/mapRoomTypeToIcon'
import { IStore } from '../../../../reducers'
import {
  getRoomsAvailableWithinDateRangeWithoutUpdatedEvent,
  getSortedRoomsByPosition,
} from '../../../../reducers/bookingCalendar/selectors/rooms'

const RoomSelect = ({
  getAvailableRooms,
  rooms,
  disabled,
  size,
  selectedRoomId,
  menuPosition = 'fixed',
  inDateRange = true,
  disableRoom = undefined,
  className = 'reservation-form-room-select',
  ...rest
}) => {
  let availableRooms = inDateRange ? getAvailableRooms : rooms

  if (!isEmpty(selectedRoomId)) {
    availableRooms = unionBy(
      availableRooms,
      rooms.filter(r => String(r.id) === String(selectedRoomId)),
      'id',
    )
  }

  return (
    <>
      <Select.ReduxField
        menuPlacement={'auto'}
        zIndex={10000}
        disabled={disabled}
        size={size}
        className={className}
        data-cy={className}
        {...rest}
      >
        {availableRooms.map((room, i) => (
          <Select.Option
            data-cy={`reservation-form-room-${i}-select-option`}
            className={`reservation-form-room-${i}-select-option`}
            disabled={disableRoom && disableRoom(room)}
            key={`room-select-${room.id}`}
            icon={mapRoomTypeToIcon(room)}
            value={room.id.toString()}
          >
            {room.name}
          </Select.Option>
        ))}
      </Select.ReduxField>
    </>
  )
}

const withRedux = connect((state: IStore, props: any) => {
  return {
    getAvailableRooms: getRoomsAvailableWithinDateRangeWithoutUpdatedEvent(
      state,
      {
        dateFrom: props.dateFrom,
        dateTo: props.dateTo,
      },
    ),
    rooms: getSortedRoomsByPosition(state),
  }
})

const withReduxForm = formValues<any>({
  dateFrom: 'dateFrom',
  dateTo: 'dateTo',
  selectedRoomId: 'roomId',
})

export default compose(
  withReduxForm,
  withRedux,
)(React.memo(RoomSelect, props => !!props.froze)) as any
